import { PhiAPI } from 'API'

const chunk = <T>(arr: T[], size: number): T[][] => {
  if (size <= 0) return [arr]
  const out: T[][] = []

  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
  return out
}

const PHI_BULK_PAGE_SIZE = 200

export const getBulkPatientsPaged = async <T = any>(phiPatientIds: number[]): Promise<T[]> => {
  const uniqueIds = Array.from(new Set(phiPatientIds))

  if (uniqueIds.length === 0) return []

  const pages = chunk(uniqueIds, PHI_BULK_PAGE_SIZE)

  const patients: T[] = []

  for (const pageIds of pages) {
    const pagePatients = (await PhiAPI.getBulkPatientsFromPHI(pageIds)) as T[]

    patients.push(...pagePatients)
  }
  return patients
}
